import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/context/AuthContext";
import { initTheme } from "@/lib/theme";

initTheme();

// The static SEO tags in index.html exist for crawlers and scrapers that do not
// execute JavaScript. Once React hydrates, react-helmet-async manages the head,
// so the static copies are removed to avoid duplicate metadata in the DOM.
document.querySelectorAll('head [data-rh="true"]').forEach((el) => {
  if (el.tagName !== "TITLE") el.remove();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </HelmetProvider>,
);
